import React, { useEffect, useState } from "react";
import { TouchableOpacity, Text, StyleSheet, Platform } from "react-native";
import moment from "moment";

import Utils, { getTimeFormat } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";

export default function TimePickerSwipeInfo({
  controller,
  timeslot = {},
  use24hFormat,
  allTimeslots,
  onTimeChanged = () => {},
}) {
  const [duration, setDuration] = useState(null);
  const [endTimeText, setEndTimeText] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);

  const timeFormat = getTimeFormat(use24hFormat);
  const dateFormat = `YYYY-MM-DD ${timeFormat}`;
  const now = Utils.nowUserTz(controller);

  // ------------------------------------- METHODS -------------------------------------
  const findFirstConfirmedDate = (timeslot) => {
    const endDate = moment(timeslot.endDate, dateFormat);

    let foundDate = null;
    allTimeslots.forEach((t) => {
      if (t != null) {
        const td = moment(t.time);
        if (!foundDate && td >= endDate && t.confirmed) {
          foundDate = moment(t.time);
        }
      }
    });

    return foundDate;
  };

  useEffect(() => {
    if (!timeslot) return;

    const timeslotDate = moment(timeslot.time, dateFormat);

    // Find next confirmed timeslot
    let nextDate = findFirstConfirmedDate(timeslot);
    let prefix = "until next confirmed timeslot";
    if (!nextDate) {
      nextDate = now;
      prefix = "until now";
    }

    const diff = nextDate.diff(timeslotDate, "minutes");
    if (diff > 0) {
      const hours = Math.floor(diff / 60);
      const minutes = Math.floor(diff % 60);

      const nextTime = nextDate.format(timeFormat);
      setEndDateTime(nextDate);
      setEndTimeText(`${prefix} (${nextTime})`);
      setDuration({ hours, minutes });
    }
  }, [timeslot]);

  const confirmTime = () => {
    onTimeChanged(endDateTime);
  };

  return !duration?.hours && !duration?.minutes ? null : (
    <TouchableOpacity style={styles.container} onPress={confirmTime}>
      <Text style={styles.time}>
        Track for {duration.hours ? `${duration.hours}h ` : ""}
        {duration.minutes ? `${duration.minutes}m` : ""}
      </Text>
      <Text style={styles.time}>{endTimeText}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginTop: 10,
  },
  time: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    textAlign: "center",
    color: AppTheme.DEFAULT_COLOR,
  },
});
